export const setSharedBrands = (value) => {
  return { type: "SET_SHARED_BRANDS", payload: value };
};

export const setSharedAccount = (value) => {
  return { type: "SET_SHARED_ACCOUNT", payload: value };
};

export const setSharedDuration = (value) => {
  return { type: "SET_SHARED_DURATION", payload: value };
};

export const setShareSelectedDeepdiveWidget = (value) => {
  return { type: "SET_SHARE_SELECTED_DEEPDIVE_WIDGET", payload: value };
};
export const setSelectedInitailProfileInfoInShareModal = (
  profileInfo,
  qucikFilterValue,
  adssetList = [],
  adssetValue = null,
  adsList = [],
  adsValue = null
) => {
  return (dispatch) => {
    dispatch({
      type: "SET_INITIAL_SHARE_SELECTED_QUICK_FILTER_VALUES",
      profileInfo: profileInfo,
      qucikFilterValue: qucikFilterValue,
      adssetList: adssetList,
      adssetValue: adssetValue,
      adsList: adsList,
      adsValue: adsValue,
    });
  };
};

export const setSelectedProfileInfoInShareModal = (
  profileInfo,
  qucikFilterValue
) => {
  return (dispatch) => {
    dispatch({
      type: "SET_SHARE_SELECTED_QUICK_FILTER_VALUE",
      profileInfo: profileInfo,
      qucikFilterValue: qucikFilterValue,
    });
  };
};
export const resetSelectedProfileInfoInShareModal = () => {
  return (dispatch) => {
    dispatch({
      type: "RESET_SHARE_SELECTED_PROFILE_SELECTION_INFO",
      profileInfo: null,
      qucikFilterValue: null,
    });
  };
};

export const setAdssetListInShareModal = (adssetList = []) => {
  return (dispatch) => {
    dispatch({
      type: "SET_ADSSET_LIST_IN_SHARE_MODAL",
      adssetList: adssetList,
    });
  };
};
export const setAdssetValueInShareModal = (adssetValue = null) => {
  return (dispatch) => {
    dispatch({
      type: "SET_ADSSET_VALUE_IN_SHARE_MODAL",
      adssetValue: adssetValue,
    });
  };
};
export const setAdsListInShareModal = (adsList = []) => {
  return (dispatch) => {
    dispatch({
      type: "SET_ADS_LIST_IN_SHARE_MODAL",
      adsList: adsList,
    });
  };
};
export const setAdsValueInShareModal = (adsValue = null) => {
  return (dispatch) => {
    dispatch({
      type: "SET_ADS_VALUE_IN_SHARE_MODAL",
      adsValue: adsValue,
    });
  };
};
